<!-- call-disposition-modal.component.html -->
<div class="disposition-modal">
  <h2 mat-dialog-title>
    <div class="dialog-title">
      <span>Call Dispositions</span>
      <button mat-flat-button color="primary" (click)="toggleForm()">
        <mat-icon>{{ showForm ? 'close' : 'add' }}</mat-icon>
        {{ showForm ? 'Close Form' : 'Add Disposition' }}
      </button>
    </div>
  </h2>
  
  <div *ngIf="errorMessage" class="error-message">
    <mat-icon>error</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>

  <mat-dialog-content>
    <!-- Form container that shows/hides based on showForm flag -->
    <div class="form-container" *ngIf="showForm">
      <form [formGroup]="dispositionForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" placeholder="Enter disposition name">
            <mat-error *ngIf="dispositionForm.get('name')?.hasError('required')">
              Name is required
            </mat-error>
          </mat-form-field>
        </div>
        
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description" placeholder="Enter description"></textarea>
          </mat-form-field>
        </div>
        
        <div class="form-row settings-row">
          <div class="setting-toggle">
            <mat-slide-toggle formControlName="is_outcome">
              Affects Lead Status
            </mat-slide-toggle>
            <mat-icon matTooltip="When enabled, using this disposition can change lead status (e.g. to Won or Lost)" class="info-icon">info</mat-icon>
          </div>
          
          <div class="setting-toggle">
            <mat-slide-toggle formControlName="active">
              Active
            </mat-slide-toggle>
          </div>
        </div>
        
        <div class="form-actions">
          <button type="submit" mat-flat-button color="primary" [disabled]="dispositionForm.invalid">
            {{ isEditing ? 'Update' : 'Add' }} Disposition
          </button>
        </div>
      </form>
    </div>
    
    <div class="dispositions-list-container">
      <h3>Current Dispositions</h3>
      <p class="drag-hint">
        <mat-icon>swap_vert</mat-icon>
        Drag items to reorder dispositions
      </p>
      
      <div *ngIf="isLoading" class="loading-spinner">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
      
      <!-- List with drag and drop -->
      <div 
        cdkDropList
        class="disposition-list"
        (cdkDropListDropped)="drop($event)"
        [cdkDropListData]="dispositions">
        
        <div class="no-data-message" *ngIf="dispositions.length === 0 && !isLoading">
          No dispositions found. Add your first disposition above.
        </div>
        
        <div class="disposition-item" *ngFor="let item of dispositions" cdkDrag>
          <div class="drag-handle" cdkDragHandle>
            <mat-icon>drag_indicator</mat-icon>
          </div>
          
          <div class="disposition-content">
            <div class="disposition-header">
              <div class="disposition-name">
                <span class="name">{{ item.name }}</span>
              </div>
              
              <div class="disposition-actions">
                <button mat-icon-button color="primary" (click)="editDisposition(item)" matTooltip="Edit">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="deleteDisposition(item.id, $event)" matTooltip="Delete">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            
            <div class="disposition-details">
              <div class="description">
                <span class="label">Description:</span>
                <span>{{ item.description || 'No description' }}</span>
              </div>
              
              <div class="attributes">
                <div class="attribute">
                  <span class="label">Affects Lead Status:</span>
                  <mat-icon *ngIf="item.is_outcome" color="primary" class="small-icon">check_circle</mat-icon>
                  <mat-icon *ngIf="!item.is_outcome" color="warn" class="small-icon">cancel</mat-icon>
                </div>
                
                <div class="attribute">
                  <span class="label">Active:</span>
                  <mat-slide-toggle [checked]="item.active" (click)="toggleActive(item, $event)" 
                                  color="primary" class="small-toggle">
                  </mat-slide-toggle>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Close</button>
  </mat-dialog-actions>
</div>